<!-- eslint-disable max-len -->
<template>
  <v-app>
    <v-app-bar
      app
      clipped-left
      flat
      outlined
    >
      <v-container class="py-0 fill-height">
        <a href="/">
          <img
            alt=""
            :src="chooseLogo"
            height="45"
          >
          <span class="sr-only">Go back to main page</span>
        </a>
      </v-container>
      <v-spacer></v-spacer>
      <v-btn
        text
        @click="$router.push('/')"
      >
        Log In
      </v-btn>
    </v-app-bar>
    <v-container fill-height>
      <v-row align="center" justify="center" style="margin-top: -177px;">
        <v-col
          cols="12"
          class="d-flex justify-center"
        >
          <v-card
            flat
            outlined
            rounded="lg"
            max-width="1200px"
            min-height="300px"
          >
            <v-row class="mt-8">
              <v-col
                cols="12"
                class="d-flex justify-center"
              >
                <div class="text-md-h4 text-h5" :style="textColor">Thank You!</div>
              </v-col>

              <v-col
                cols="12"
                class="d-flex justify-center"
              >
                <div class="text-md-h5 text-h6 font-weight-light text-center px-4">Thank you for investing the time to complete this process. We know it's a lot of information to gather and we appreciate your time.</div>
              </v-col>
              <v-col cols="12" class="mb-5">
                <div class="text-body-1 text-center">This information will help us provide you the best possible pricing and service.</div>
                <div class="text-body-1 text-center">Someone will reach out to you shortly with more information.</div>
              </v-col>

              <div v-if="Object.keys(companyStatus).length > 0" style="width: 100%;">
                <v-col cols="12" class="mb-5 px-8" v-if="companyStatus.benefitStatus !== null && companyStatus.benefitStatus !== 'Signed' && companyStatus.hasBenefitPacket">
                  <v-alert
                    prominent
                    type="info"
                  >
                    <v-row align="center">
                      <v-col class="grow">
                        <div class="text-body-1 text-center">It looks like you still need to finish your benefits application.</div>
                      </v-col>
                      <v-col class="shrink">
                        <v-btn
                          @click="$router.push({ name: 'login' });"
                        >Finish</v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>

                <v-col cols="12" class="mb-5 px-8" v-if="companyStatus.registrationStatus !== null && companyStatus.registrationStatus !== 'Signed'">
                  <v-alert
                    prominent
                    type="info"
                  >
                    <v-row align="center">
                      <v-col class="grow">
                        <div class="text-body-1 text-center">It looks like you still need to finish your registration application.</div>
                      </v-col>
                      <v-col class="shrink">
                        <v-btn
                          @click="$router.push({ name: 'login' });"
                        >Finish</v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </div>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-footer
      padless
      v-bind="attrs"
      dark
    >
      <v-card
        flat
        tile
        flex
        width="100%"
        class="text-center white--text"
      >
        <v-card-text>
          <v-btn
            icon
            class="mx-4 white--text"
            href="https://www.facebook.com/LandrumHR"
          >
            <v-icon size="24px">mdi-facebook</v-icon>
          </v-btn>
          <v-btn
            icon
            class="mx-4 white--text"
            href="https://twitter.com/LandrumHR"
          >
            <v-icon size="24px">mdi-twitter</v-icon>
          </v-btn>
          <v-btn
            icon
            class="mx-4 white--text"
            href="https://www.youtube.com/user/LandrumCompanies"
          >
            <v-icon size="24px">mdi-youtube</v-icon>
          </v-btn>
          <v-btn
            icon
            class="mx-4 white--text"
            href="https://www.linkedin.com/company/landrum-hr?trk=ppro_cprof"
          >
            <v-icon size="24px">mdi-linkedin</v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text class="white--text">
          If you have any questions during this process, please reach out to Business Operations at <a class="blue--text" href="mailto:businessops@landrumhr.com">businessops@landrumhr.com</a>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="white--text">
          &copy;{{ new Date().getFullYear() }} — <strong>Landrum</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'ThankYou',
  data: () => ({
    attrs: {
      fixed: true,
    },
    companyId: null,
  }),
  created() {
    // eslint-disable-next-line no-underscore-dangle
    window._paq.push(['trackEvent', 'Registration', 'Signatures', 'Thank you for signing']);
    const darkMode = localStorage.getItem('darkMode');

    if (darkMode !== '' && typeof (darkMode) === 'string') {
      this.$vuetify.theme.dark = (darkMode === 'true');
    }

    this.companyId = localStorage.getItem('company');
    if (this.companyId) {
      this.$store.dispatch('getCompanyStatus', this.companyId);
    }
  },
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    chooseLogo() {
      if (this.$vuetify.theme.dark) {
        return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
      }

      return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
    },
    companyStatus() {
      const { companyStatus } = this.$store.state;
      if (Object.keys(companyStatus).length === 0) {
        return {
          benefitStatus: null,
          registrationStatus: null,
        };
      }

      return this.$store.state.companyStatus;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
